// extracted by mini-css-extract-plugin
export default {"block":"ui_block__a9Pmd","iconWrapper":"ui_iconWrapper__dhtwY","text":"ui_text__hTpzJ"};